/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { companyActions } from '../../redux/actions/companyActions';
import { Loading } from '../../helpers/utils';
import { coursesActions } from '../../redux/actions/coursesActions';

const CompanyLoader = (props) => {
  const loadData = async () => {
    // eslint-disable-next-line no-prototype-builtins
    if (!props.company.hasOwnProperty('company')) {
      props.getCompany(props.auth.company);
    }
    if (props.company?.company?.type !== '2') {
      if (props.user && props.user.type && props.user.type === 2) {
        props.abortCoursesRequest();
      }
      if (props.user && props.user.type && props.user.type === 3) {
        await props.getCoursesByProfessor(props.user.email);
      }
      if (props.user && props.user.type && props.user.type === 4) {
        await props.getCoursesByStudent(props.user.email);
      }
    }
  };
  useEffect(() => {
    loadData();
  }, [props.auth]);

  return (
    props.company.requesting || (props.company?.company?.type !== '2' && props.courses.requesting) ? (
      <Loading />
    ) : (
      <>{props.children}</>
    )
  );
};

function mapState(state) {
  const { auth } = state.authentication;
  const { company } = state;
  const { courses } = state;
  const { user } = state.user;
  return {
    company,
    auth,
    user,
    courses,
  };
}

const actionCreators = {
  getCompany: companyActions.getCompany,
  getCourses: coursesActions.getCourses,
  getCoursesByProfessor: coursesActions.getCoursesByProfessor,
  getCoursesByStudent: coursesActions.getCoursesByStudent,
  abortCoursesRequest: coursesActions.abortCoursesRequest,
};

const connectedGroupList = connect(mapState, actionCreators)(CompanyLoader);

export default connectedGroupList;
